import { LngLat } from "mapbox-gl";

export const MAP_INITIAL_VIEW = {
  longitude: -100,
  latitude: 40,
  zoom: 3.5,
};
export const DEFAULT_ZOOM = 12;
export const DEFAULT_PADDING = 10;

export const ONBOARDING_ROUTES = {
  WELCOME: "welcome",
  FIELD_BOUNDARIES: "field-boundaries",
  FARM_DETAILS: "farm-details",
  VERIFY_EMAIL: "verify-email",
  COMPLETE: "complete",
};

interface OnboardingStep {
  path: string;
  label: string;
}

export const ONBOARDING_STEPS: OnboardingStep[] = [
  {
    path: ONBOARDING_ROUTES.WELCOME,
    label: "Getting started",
  },
  {
    path: ONBOARDING_ROUTES.FIELD_BOUNDARIES,
    label: "Field boundaries",
  },
  {
    path: ONBOARDING_ROUTES.FARM_DETAILS,
    label: "Farm details",
  },
  {
    path: ONBOARDING_ROUTES.VERIFY_EMAIL,
    label: "Verify email",
  },
  {
    path: ONBOARDING_ROUTES.COMPLETE,
    label: "",
  },
];

export const MAPBOX_TEST_HOOK = "_mapboxgl";

// Coordinates in Clarksdale, Mississippi
export const DEFAULT_MAP_CENTER_COORDINATES: LngLat = new LngLat(
  -90.61647733930027,
  34.18565228177373,
);

export const FARM_WIDE_FIELD = {
  id: "all-fields",
  name: "All Fields",
};

export const FORM_SUBMIT_ERROR_MESSAGE =
  "* Please fix the errors above before continuing";
